import React, { useEffect, useState } from 'react';
import { customStyle } from 'helper';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'lodash';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

const form = {
  rptax_land_classification_id: ''
}

function LandClassification({
  getLandClassificationList,
  landClassificationList,
  handleOnSubmit,
}) {

  useEffect(() => {
    getLandClassificationList();
  }, []);

  const [formData, setFormData] = useState(form);

  const selectOptions = landClassificationList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const handleChangeSelect = e => {
    setFormData({
      ...formData,
      rptax_land_classification_id: e ? e.value : '',
    });

    handleOnSubmit({
      ...formData,
      rptax_land_classification_id: e ? e.value : '',
      isPaginate: 1
    });
  };

  return (
    <div className="col-12 align-items-right mb-3">
      <div>
        <label className="form-label mt-2 mb-0">
          <span className="text-muted">
            <h6>Filter By Land Classification:</h6>
          </span>
        </label>
      </div>
      <Select
        name="rptax_land_classification_id"
        value={
          selectOptions.find(item => `${formData.rptax_land_classification_id}` === `${_.get(item, 'value')}`) || ''
        }
        styles={customStyle}
        isClearable  
        options={selectOptions}
        onChange={e => {
          handleChangeSelect(e);
        }}
      />
    </div>
  );
}

LandClassification.defaultProps = {
}

LandClassification.propTypes = {
  getLandClassificationList: PropTypes.instanceOf(Function).isRequired,
  landClassificationList: PropTypes.instanceOf(Array).isRequired,
  handleOnSubmit: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  landClassificationList: _.get(api, `${c.GET_LAND_CLASSIFICATION_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandClassification);
